import { queryOptions, useQuery } from '@tanstack/react-query';

import { workflowTemplatesApi } from '../api/workflows-api';

import { workflowKeys } from './workflow-keys';

export function workflowTemplateQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: workflowKeys.detail(storeId, id),
    queryFn: () => workflowTemplatesApi.get(storeId, id),
  });
}

export function useWorkflowTemplate(storeId: string, id: string) {
  return useQuery(workflowTemplateQueryOptions(storeId, id));
}
